var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 5.5C4.52614 5.5 4.75 5.72386 4.75 6V12C4.75 12.2761 4.52614 12.5 4.25 12.5C3.97386 12.5 3.75 12.2761 3.75 12V6C3.75 5.72386 3.97386 5.5 4.25 5.5Z",
    fill: "#252B5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 5.5C7.02614 5.5 7.25 5.72386 7.25 6V12C7.25 12.2761 7.02614 12.5 6.75 12.5C6.47386 12.5 6.25 12.2761 6.25 12V6C6.25 5.72386 6.47386 5.5 6.75 5.5Z",
    fill: "#252B5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 6C9.75 5.72386 9.52614 5.5 9.25 5.5C8.97386 5.5 8.75 5.72386 8.75 6V12C8.75 12.2761 8.97386 12.5 9.25 12.5C9.52614 12.5 9.75 12.2761 9.75 12V6Z",
    fill: "#252B5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 3C13.25 3.55228 12.8023 4 12.25 4H11.75V13C11.75 14.1046 10.8546 15 9.75 15H3.75C2.64543 15 1.75 14.1046 1.75 13V4H1.25C0.697715 4 0.25 3.55228 0.25 3V2C0.25 1.44772 0.697715 1 1.25 1H4.75C4.75 0.447715 5.19772 0 5.75 0H7.75C8.30229 0 8.75 0.447715 8.75 1H12.25C12.8023 1 13.25 1.44772 13.25 2V3ZM2.86803 4L2.75 4.05902V13C2.75 13.5523 3.19772 14 3.75 14H9.75C10.3023 14 10.75 13.5523 10.75 13V4.05902L10.632 4H2.86803ZM1.25 3V2H12.25V3H1.25Z",
    fill: "#252B5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.ee153a090ba7d07bd19ae86c3d61718f.svg";
export { ForwardRef as ReactComponent };